import { QuoteDetails } from '@domgen/dgx-fe-basket';
import { generateId } from '@domgen/dgx-fe-common';
import {
  PaysafeFormValue,
  PaysafePaymentType,
  PaysafeTokenizationOptions,
  PaysafeTransactionType,
} from '@checkout/util-models';
import { formatPaysafeCustomerDetails } from '../paysafe-customer-details/paysafe-customer-details.utils';

export function formatPaysafeTokenizeOptions(
  formValue: PaysafeFormValue,
  quote?: QuoteDetails
): PaysafeTokenizationOptions | undefined {
  const customerDetails = formatPaysafeCustomerDetails(formValue);

  if (!customerDetails || !quote || !quote.cardPaymentOption) {
    return;
  }

  const quoteTotal: number =
    quote.cardPaymentOption.fee + (quote.cardPaymentOption.tax ?? 0);

  // Paysafe requires total sent as quoteTotal * 100
  const amount: number = Math.round(quoteTotal * 10000) / 100;

  return {
    amount,
    customerDetails,
    merchantRefNum: generateId(),
    paymentType: PaysafePaymentType.Card,
    transactionType: PaysafeTransactionType.Verification,
  };
}
